import { isBrowser } from '@noths/polaris-client-utils';
import type { Dictionary } from '@noths/polaris-dev-ts-recipes';

import type { GAEvent } from './types';

export const sendGAEvent = async <T extends Dictionary<T> & Dictionary<GAEvent>>(
  eventOrEvents: T | T[],
) => {
  const IS_BROWSER = isBrowser();

  if (!IS_BROWSER) {
    return Promise.resolve();
  }

  const rawEvents = Array.isArray(eventOrEvents) ? eventOrEvents : [eventOrEvents];
  const promises: unknown[] = [];
  const events = rawEvents.map((event) => {
    let resolver: (v?: unknown) => void;
    const promise = new Promise((resolve) => {
      resolver = resolve;
    });

    promises.push(promise);

    return {
      ...event,
      eventCallback: () => {
        if (event.eventCallback) {
          event.eventCallback();
        }
        resolver();
      },
      eventTimeout: event.eventTimeout || 500,
    };
  });

  if (window.dataLayer) {
    window.dataLayer.push(...events);
  }

  if (!window.google_tag_manager) {
    setTimeout(() => events.forEach((event) => event.eventCallback()), 200);
  }

  await Promise.all(promises);

  return Promise.resolve();
};
